import React, { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { useStore } from "../../hook-store/store.js";

import { ollamaNodeJsUrl } from "../../App.js";

import { marks } from "../../utils/marks.jsx";
import "./PdfToText.css";


export default function PdfToTextAbout(props) {
    const {} = props;

    const [t] = useTranslation("translation");
    
    const [store, dispatch] = useStore();
    // const { 
    // } = store.mlSpeechStore;


    let pdfToTextAboutBody;

    pdfToTextAboutBody = (
      <div>
        <p>
          In PDF to text,{' '}
          {t('pdfToText01', 'user can get text data from pdf file, and create text file from the text data.')}
        </p>
        <p>
          {t('pdfToText02', 'When pdf file have multiple pages, user can create text file from selected pages.')}
        </p>
        <p>{t('pdfToText24', 'This tool can extract both characters and numbers in tables on pdf file.')}</p>
        <p>
          {marks.filePdfOMark} {`-->`} {marks.fileTextOMark} 
        </p>
      </div>
    );


    return (
        <Fragment>
          <div>{pdfToTextAboutBody}</div>
        </Fragment>
    );
  };
